import { render, staticRenderFns } from "./LoadingViewPlaceholder.vue?vue&type=template&id=bf5252c4"
import script from "./LoadingViewPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingViewPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports